import React, { useCallback, useState } from 'react';
import {
  categorySuggestionIcon,
  categorySuggestionIconLoading,
  suggestionIconWrap,
} from './suggestion-list-item-styles';
import { useOptimisedImages } from '@navi-toolbox/hooks';

type Props = {
  src: string | null;
  alt: string;
  fallback: React.ReactNode;
};

export const SuggestionListItemNewImage: React.FC<Props> = ({ src, alt, fallback }) => {
  const [loading, setLoading] = useState(true);
  const [shoulRenderFallback, setShoulRenderFallback] = useState(!src);

  const onError = useCallback(() => {
    setShoulRenderFallback(true);
  }, [setShoulRenderFallback]);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, [setLoading]);

  const optimizedImage = useOptimisedImages({
    src: src,
    sizes: {
      rest: {
        h: '40',
        w: '40',
      },
    },
    options: {
      b: 'transparent',
      c: 'pad',
    },
  });

  return (
    <>
      {shoulRenderFallback ? (
        <div className={suggestionIconWrap}>{fallback}</div>
      ) : (
        <>
          <img
            data-qa="new-suggestion-button-icon"
            src={optimizedImage.rest?.x || ''}
            srcSet={`${optimizedImage.rest?.xx} 2x`}
            className={categorySuggestionIcon}
            alt={alt}
            onError={onError}
            onLoad={onLoad}
          ></img>
          {loading && <div className={categorySuggestionIconLoading}></div>}
        </>
      )}
    </>
  );
};
